// src/FlightsContext.js
import React, { createContext, useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid'; // or use Date.now() for simpler ID

const FlightsContext = createContext();

export function FlightsProvider({ children }) {
  // Keep an array of flights, each flight is { id, tdrData, brockData, createdAt, ... }
  const [flights, setFlights] = useState([]);

  function addFlight({ tdrData, brockData }) {
    const newFlight = {
      id: uuidv4(),          // unique ID
      createdAt: Date.now(), // for sorting if needed
      tdrData,
      brockData
    };
    setFlights((prev) => [...prev, newFlight]);
    return newFlight.id; // return the ID so we can navigate
  }

  function getFlightById(flightId) {
    return flights.find((f) => f.id === flightId);
  }

  return (
    <FlightsContext.Provider value={{ flights, addFlight, getFlightById }}>
      {children}
    </FlightsContext.Provider>
  );
}

// Custom hook for easy usage
export function useFlights() {
  return useContext(FlightsContext);
}